const StatusSetter = (status) => {
  switch (status) {
    case "NO":
      return "نیازمند تعیین سطح";
    case "TE":
      return "تست داده شده";
    case "TD":
      return "زمان تعیین سطح داده شده";
    case "RE":
      return "ثبت نام شده";
    case "NC":
      return "تماس اول گرفته شود";
    case "FC":
      return "تماس دوم گرفته شود";
    case "SC":
      return "پیگیری طولانی مدت";
    default:
      return "نامشخص";
  }
};
export default StatusSetter;
